var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 25.9795V24C19.5 23.7239 19.7239 23.5 20 23.5C20.2761 23.5 20.5 23.7239 20.5 24V25.9795C23.4149 25.739 25.739 23.4149 25.9795 20.5L24 20.5C23.7239 20.5 23.5 20.2761 23.5 20C23.5 19.7239 23.7239 19.5 24 19.5L25.9795 19.5C25.739 16.5851 23.4149 14.261 20.5 14.0205V16C20.5 16.2761 20.2761 16.5 20 16.5C19.7239 16.5 19.5 16.2761 19.5 16V14.0205C16.5851 14.261 14.261 16.5851 14.0205 19.5H16C16.2761 19.5 16.5 19.7239 16.5 20C16.5 20.2761 16.2761 20.5 16 20.5H14.0205C14.261 23.4149 16.5851 25.739 19.5 25.9795ZM27 20C27 23.866 23.866 27 20 27C16.134 27 13 23.866 13 20C13 16.134 16.134 13 20 13C23.866 13 27 16.134 27 20ZM20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.eff8dae53f9538e0119025551fe27f42.svg";
export { ForwardRef as ReactComponent };